"use strict";

exports.__esModule = true;
exports.FiftyFiftyReducers = void 0;
/* eslint-disable import/prefer-default-export */

var promos = function promos(store, action) {
  if (action.type === 'ADD_PROMO') {
    var currentPromos = store.promos.slice();
    if (!currentPromos.find(function (promo) {
      return promo.promotionId === action.value.promotionId;
    })) {
      currentPromos.push(action.value);
    }
    return {
      promos: currentPromos
    };
  }
  if (action.type === 'CLAIM_PROMO') {
    var _currentPromos = store.promos.slice();
    var unclaimedPromo = _currentPromos.find(function (promo) {
      return promo.locationId < action.position && !promo.ctaId;
    }) || _currentPromos.find(function (promo) {
      return !promo.ctaId;
    });
    if (unclaimedPromo) {
      unclaimedPromo.ctaId = action.ctaId;
      return {
        promos: _currentPromos
      };
    }
  }
  if (action.type === 'UPDATE_PROMO') {
    var _currentPromos2 = store.promos.slice();
    var promoToUpdate = _currentPromos2.find(function (promo) {
      return promo.locationId === action.locationId;
    });
    if (promoToUpdate) {
      promoToUpdate.promotionId = action.promotionId;
      promoToUpdate.promotionName = action.promotionName;
      promoToUpdate.bannerPosition = action.bannerPosition;
      return {
        promos: _currentPromos2
      };
    }
  }
  return store || {
    promos: []
  };
};
var FiftyFiftyReducers = {
  promos: promos
};
exports.FiftyFiftyReducers = FiftyFiftyReducers;